import { gql } from 'urql';

export const mutationRemoveWorkflowOutput = gql`
  mutation RemoveWorkflowOutput($paramId: String!) {
    removeWorkflowOutput(outputParameterId: $paramId) {
      id
    }
  }
`;
